import { useState } from 'react';
import {
  IconButton,
  FormControl,
  InputAdornment,
  FormHelperText,
  Button,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@material-ui/icons';

import {
  Text,
  Link,
  ButtonComponent,
  GoogleLoginButton,
} from '../../../../components';
import Input from '../../../../components/Form/Input';
import styles, { Footer } from '../styles';
import ForgotPasswordModal from './ForgotPasswordModal';

const LoginForm = ({
  emailNull,
  onClick,
  passwordNull,
  valueEmail,
  onChangeEmail,
  emailLabelError,
  password,
  onChangePass,
  passWordLabelError,
  validateEmail,
  validatePassword,
  showLoading,
  startNow,
}) => {
  const [values, setValues] = useState({ password: '', showPassword: false });
  const [pendingGoogleLogin, setPendingGoogleLogin] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => event.preventDefault();

  return (
    <>
      <FormControl sx={styles.textField} variant="standard" disabled={true}>
        <Text variant="h3" color="primary">
          Bem-vindo novamente!
        </Text>
        <Text variant="hintText" marginBottom={2}>
          Não possui uma conta?{' '}
          <Link onClick={startNow} disabled={showLoading || pendingGoogleLogin}>
            Comece agora.
          </Link>
        </Text>

        <Input
          error={emailNull}
          placeholder="E-mail"
          value={valueEmail}
          onChange={onChangeEmail}
          type="email"
          name="email"
          helperText={emailLabelError}
          onKeyUpCapture={validateEmail}
          disabled={showLoading || pendingGoogleLogin}
        />
      </FormControl>

      <FormControl error={passwordNull} sx={styles.textField} variant="standard">
        <Input
          type={values.showPassword ? 'text' : 'password'}
          placeholder="Senha"
          value={password}
          onChange={onChangePass}
          onKeyUpCapture={validatePassword}
          disabled={showLoading || pendingGoogleLogin}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  size="large"
                  disabled={showLoading || pendingGoogleLogin}
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <FormHelperText id="component-error-text">{passWordLabelError}</FormHelperText>
      </FormControl>

      <Footer>
        <ButtonComponent
          size="large"
          loading={showLoading}
          disabled={showLoading || pendingGoogleLogin}
          onClick={onClick}
        >
          Entrar
        </ButtonComponent>

        <GoogleLoginButton
          focusCreateAccountTab={startNow}
          isLoading={pendingGoogleLogin}
          setLoading={setPendingGoogleLogin}
        />

        <Button onClick={() => setOpenModal(true)} sx={styles.btnGoogle}>
          Esqueci minha senha.
        </Button>

        <ForgotPasswordModal open={openModal} handleClose={() => setOpenModal(false)} />
      </Footer>
    </>
  );
};

export default LoginForm;
